export const LOCALIZATION_COMMON = {
   PAGE_NOT_FOUND: "Page not found.",
};
